import { PageHeader } from '@/app/shell'
import { Users } from '@/modules/admin/users'
import { SetariTva } from './tva'
import { SetariSincronizare } from './sincronizare'
import { SetariSaga } from './saga'
import { SetariEmail } from './email'
import { SetariJoburi } from './joburi'
import { SetariImport } from './import'
import { SetariObservatii } from './observatii'

export type CopilSetari =
  | 'utilizatori' | 'tva' | 'sincronizare' | 'saga' | 'email' | 'joburi' | 'import' | 'observatii'

const TITLU: Record<CopilSetari, string> = {
  utilizatori: 'Utilizatori si roluri',
  tva: 'Cote de TVA',
  sincronizare: 'Sincronizare QTravel',
  saga: 'Contabilitate SAGA',
  email: 'Email',
  joburi: 'Joburi automate',
  import: 'Import fisiere',
  observatii: 'Observatii client',
}

export function Setari({ copil }: { copil: CopilSetari }) {
  /** Utilizatorii isi aduc singuri antetul (au numaratoarea de conturi in el), restul
   *  ecranelor primesc antetul de aici. */
  if (copil === 'utilizatori') return <Users />
  return (
    <>
      <PageHeader title={TITLU[copil]} />
      {copil === 'tva' && <SetariTva />}
      {copil === 'sincronizare' && <SetariSincronizare />}
      {copil === 'saga' && <SetariSaga />}
      {copil === 'email' && <SetariEmail />}
      {copil === 'joburi' && <SetariJoburi />}
      {copil === 'import' && <SetariImport />}
      {copil === 'observatii' && <SetariObservatii />}
    </>
  )
}
